import React, { useState, useEffect } from "react"
import _ from "lodash"
import { Checkbox_s } from "styles/input-styles"

type CheckboxInputProps = {
  attrs?: Function
  data: any
  field: string|string[]
  persist: Function
  className: string
  propertyId?: number
}

const CheckboxInput = (props: CheckboxInputProps) => {
  const initialValue = _.get(props.data, props.field);
  const attrs = props.attrs && props.attrs(props.field) || {}
  const [val, updateVal] = useState<boolean>(initialValue || false)

  useEffect(() => {
    if (_.isNil(initialValue) && val === true) {
      updateVal(false)
    }
  }, [initialValue])

  useEffect(() => {
    updateVal(initialValue)
  }, [initialValue])

  return (
    <Checkbox_s
      {...attrs}
      className={props.className}
      onChange={(e) => { updateVal(e.checked); props.persist(e.checked, props.field)}}
      checked={val}
    >
    </Checkbox_s>
  )
}

export default CheckboxInput

